import { DoqType } from '@ardoq/doq';
import { ViewIds } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import { emptyView$ } from 'views/streams/emptyView$';
import { NoConnectedComponentsDoq } from '@ardoq/graph';
import { type I18nLocale } from '@ardoq/i18n';
import { NoDataAvailableDoq } from 'tabview/graphViews/emptyStates/NoDataAvailableDoq';
import { NoDataWithFiltersDoq } from 'tabview/graphViews/emptyStates/NoDataWithFiltersDoq';
import { onViewSettingsUpdate } from 'tabview/onViewSettingsUpdate';

type EmptyStateProps = {
  noConnectedComponents: boolean;
  hasActiveFilter: boolean;
  isPresentationMode: boolean;
  isWorkspaceEmpty: boolean;
  viewId: ViewIds;
  i18nLocale: I18nLocale;
};

const EmptyStateBase = ({
  noConnectedComponents,
  hasActiveFilter,
  isPresentationMode,
  isWorkspaceEmpty,
  viewId,
  i18nLocale,
}: EmptyStateProps) => {
  if (isWorkspaceEmpty) {
    return (
      <NoDataAvailableDoq
        doqType={DoqType.RELATIONSHIPS_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  if (hasActiveFilter) {
    return (
      <NoDataWithFiltersDoq
        doqType={DoqType.RELATIONSHIPS_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  if (noConnectedComponents) {
    return (
      <NoConnectedComponentsDoq
        doqType={DoqType.RELATIONSHIPS_ERROR}
        viewId={viewId}
        includeActions={!isPresentationMode}
        onViewSettingsUpdate={onViewSettingsUpdate}
        i18nLocale={i18nLocale}
      />
    );
  }

  return null;
};

export const EmptyState = connect(EmptyStateBase, emptyView$);
